import { Action as SimpleAction } from 'typed/utils/redux';

export interface IAction<T extends string, P> extends SimpleAction<T> { type: T; payload: P; }

export interface IActionCreator {
    <T extends string>(type: T): IAction<T, void>;
    <T extends string, P>(type: T, payload: P): IAction<T, P>;
}

const action: IActionCreator = <T extends string, P>(type: T, payload?: P) => ({ type, payload });

export default action;